export default __webpack_public_path__ + "static/media/load.90672f1d.gif";